function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.2002,8.2001 L13.8002,8.2001 C12.6952,8.2001 11.8002,7.3041 11.8002,6.2001 L11.8002,1.8941 C11.8002,0.9971 11.1862,0.1671 10.3012,0.0241 C9.1732,-0.1579 8.2002,0.7061 8.2002,1.8001 L8.2002,6.2001 C8.2002,7.3041 7.3042,8.2001 6.2002,8.2001 L1.8942,8.2001 C0.9972,8.2001 0.1672,8.8131 0.0242,9.6991 C-0.1578,10.8271 0.7062,11.8001 1.8002,11.8001 L6.2002,11.8001 C7.3042,11.8001 8.2002,12.6951 8.2002,13.8001 L8.2002,18.1061 C8.2002,19.0021 8.8132,19.8321 9.6992,19.9751 C10.8272,20.1581 11.8002,19.2931 11.8002,18.2001 L11.8002,13.8001 C11.8002,12.6951 12.6952,11.8001 13.8002,11.8001 L18.1062,11.8001 C19.0022,11.8001 19.8322,11.1861 19.9752,10.3011 C20.1582,9.1731 19.2932,8.2001 18.2002,8.2001",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/plus.a457dee0.svg";
export { SvgComponent as ReactComponent };